import { gql } from '@apollo/client';
import { Classroom } from '@/types/classroom';

export interface GetOngoingClassroomsVariables {
    now: string;
}

export interface GetOngoingClassroomsResponse {
    testrooms: Classroom[];
}

export const GET_ONGOING_CLASSROOMS = gql`
    query GetOngoingClassrooms($now: DateTime!) {
        testrooms(orderBy: { startTime: asc }, where: { endTime: { gte: $now } }) {
            id
            testroomName
            startTime
            endTime
            otp
            lessonVersion {
                id
                lessonName
            }
            class {
                id
            }
            passlock
            offlineMode
            writingHints
            freeStyleMode
        }
    }
`;

export interface UpdateClassroomVariables {
    where: {
        id: string;
    };
    data: object;
}

export const UPDATE_CLASSROOM = gql`
    mutation UpdateTestroom($where: TestroomWhereUniqueInput!, $data: TestroomUpdateInput!) {
        updateTestroom(where: $where, data: $data) {
            id
        }
    }
`;

export interface PublishLessonVariables {
    lessonID: string;
}

export interface PublishLessonResponse {
    publishLesson: {
        id: string;
    };
}

export const PUBLISH_LESSON = gql`
    mutation PublishLesson($lessonID: ID!) {
        publishLesson(lessonID: $lessonID) {
            id
        }
    }
`;

export interface CreateClassroomVariables {
    name: string;
    lessonVersion: string;
    class: string;
    passlock?: string;
}

export interface CreateClassroomResponse {
    createTestroom: Classroom;
}

export const CREATE_CLASSROOM = gql`
    mutation createClassroom($name: String!, $lessonVersion: ID!, $class: ID!, $passlock: String) {
        createTestroom(data: { testroomName: $name, lessonVersion: { connect: { id: $lessonVersion } }, class: { connect: { id: $class } }, passlock: $passlock }) {
            id
            testroomName
            startTime
            endTime
            otp
            lessonVersion {
                id
                lessonName
            }
            class {
                id
            }
            passlock
            offlineMode
            writingHints
            freeStyleMode
        }
    }
`;
